import { countryCodes } from "react-native-country-codes-picker/constants/countryCodes";

export type CountryMetadata = {
  code: string;
  flag: string;
  names: {
    en: string;
    fr: string;
  };
};

const ADDITIONAL_COUNTRIES: CountryMetadata[] = [
  {
    code: "BQ",
    flag: "🇧🇶",
    names: { en: "Caribbean Netherlands", fr: "Pays-Bas caribéens" },
  },
  {
    code: "BV",
    flag: "🇧🇻",
    names: { en: "Bouvet Island", fr: "Île Bouvet" },
  },
  {
    code: "CW",
    flag: "🇨🇼",
    names: { en: "Curaçao", fr: "Curaçao" },
  },
  {
    code: "EH",
    flag: "🇪🇭",
    names: { en: "Western Sahara", fr: "Sahara occidental" },
  },
  {
    code: "HM",
    flag: "🇭🇲",
    names: {
      en: "Heard Island and McDonald Islands",
      fr: "Îles Heard-et-MacDonald",
    },
  },
  {
    code: "SS",
    flag: "🇸🇸",
    names: { en: "South Sudan", fr: "Soudan du Sud" },
  },
  {
    code: "TF",
    flag: "🇹🇫",
    names: {
      en: "French Southern Territories",
      fr: "Terres australes françaises",
    },
  },
  {
    code: "UM",
    flag: "🇺🇲",
    names: {
      en: "United States Minor Outlying Islands",
      fr: "Îles mineures éloignées des États-Unis",
    },
  },
];

const OTHER_COUNTRY: CountryMetadata = {
  code: "XX",
  flag: "🌍",
  names: { en: "Other", fr: "Autre" },
};

const countryMetadataByCode = new Map<string, CountryMetadata>();

for (const country of countryCodes) {
  if (country.code === "AN") continue;

  const englishName = country.name.en ?? country.name.fr ?? country.code;

  countryMetadataByCode.set(country.code, {
    code: country.code,
    flag: country.flag,
    names: {
      en: englishName,
      fr: country.name.fr ?? englishName,
    },
  });
}

for (const country of ADDITIONAL_COUNTRIES) {
  countryMetadataByCode.set(country.code, country);
}

/** The complete current ISO alpha-2 country/territory coverage plus Other. */
export const COUNTRIES: CountryMetadata[] = [
  ...[...countryMetadataByCode.values()].sort((a, b) =>
    a.names.en.localeCompare(b.names.en),
  ),
  OTHER_COUNTRY,
];

export function getCountryName(
  country: CountryMetadata,
  locale: "en" | "fr",
): string {
  return country.names[locale] ?? country.names.en;
}
